import Angular from "angular";
import Template from "./booking-list.html";

export default Angular.module('booking-list', [])
    .component('bookingList', {
        template: Template,
        bindings: {
            bookings: '<',
            showDate: '<',
            onBookingTap: '&'
        }
    })



// WEBPACK FOOTER //
// ./src/modules/main/views/bookings/booking-list.js